import { bool, func } from "prop-types";
import React, { useRef } from "react";

import Modal from "@components/shared/Modal";
import { Button } from "@components/shared/Button";

import { useTranslation } from "@lib/i18n";

const VehicleQuantityInfoModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const modalLastElement = useRef(null);

  return (
    <Modal
      isOpen={isOpen}
      withCloseIcon
      lastElement={modalLastElement}
      ariaLabel={t("VehicleQuantityInfo.modalMessage")}
      onClose={onClose}
    >
      <div className="flex flex-col items-center gap-12 pt-16 pb-1">
        <p>{t("VehicleQuantityInfo.modalMessage")}</p>
        <Button
          ref={modalLastElement}
          variant="secondary"
          onClick={onClose}
          data-id="vehicles-quantity-info-modal-confirm-btn"
        >
          {t("VehicleQuantityInfo.modalSubmitButton")}
        </Button>
      </div>
    </Modal>
  );
};

VehicleQuantityInfoModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
};

export default VehicleQuantityInfoModal;
